<template>
  <article class="contents-content">
    <div class="contents-content__content">
      <div class="content-in-area">
        <h1 class="content__title with--button">버스 관리
          <v-btn v-if="$store.state.userInfo && $store.state.userInfo.writeBus" depressed rounded outlined color="secondary" class="ml-5" @click="setCreateMode">
            <v-icon>add</v-icon> 셔틀버스 추가
          </v-btn>
        </h1>
        <v-container>
          <v-row>
            <nav class="content-left-menu">
              <transition name="fade">
                <div v-if="busList && busList.length > 0">
                  <ul
                    class="content-menu-list"
                    ref="contentMenu"
                  >
                    <li
                      v-for="(bus, idx) in busList"
                      :key="bus.id"
                      :class="['content-menu__item', {'is--active' : activeIndex === idx}]"
                      @click="setCurrentBus(bus)"
                    >
                      <strong
                        class="menu__item-main"
                        @click="selectMainItem(idx)"
                      >
                        {{ bus.carNumber }}
                      </strong>
                    </li>
                  </ul>
                </div>
                <p class="content--empty" v-if="busList && busList.length === 0">등록된 셔틀버스가 없습니다.</p>
              </transition>
            </nav>
            <div class="content--has-menu">
              <v-card outlined class="content__content">
                <v-card-text>
                  <v-form
                    ref="form"
                    v-model="valid"
                    v-if="bus && bus.id || mode === 'CREATE'"
                  >
                    <v-container>
                      <v-row class="pa-2">
                        <v-col cols="10" class="pa-0">
                          <v-text-field
                            prepend-icon="directions_bus"
                            v-model="bus.carNumber"
                            label="버스번호"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" class="pa-0">
                          <carousel
                            :key="bus.id"
                            :imageObject.sync="busImage"
                            is-with-padding
                          />
                        </v-col>
                        <v-col cols="10" class="pa-0">
                          <v-text-field
                            prepend-icon="group"
                            type="number"
                            v-model="bus.size"
                            label="최대탑승인원"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="10" class="pa-0">
                          <v-text-field
                            prepend-icon="more_horiz"
                            v-model="bus.comments"
                            name="input-10-2"
                            label="비고"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row align="center">
                        <v-col class="text-center mb-2">
                          <v-btn
                            v-if="$store.state.userInfo && $store.state.userInfo.writeBus"
                            :disabled="!valid"
                            color="primary"
                            class="mt-4"
                            @click="onSubmit"
                            rounded
                            depressed
                            large
                          >
                            {{ mode === 'CREATE' ? '등록하기' : '수정하기' }}
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row v-if="mode === 'UPDATE'">
                        <v-col class="mt-2">
                          <v-btn
                            v-if="$store.state.userInfo && $store.state.userInfo.writeBus && bus.id"
                            color="error"
                            depressed
                            rounded
                            outlined
                            dark
                            @click="onRemoveBus">
                            <v-icon>remove</v-icon>
                            버스제거
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-form>
                  <p v-else class="content--empty">선택된 셔틀버스가 없습니다.</p>
                </v-card-text>
              </v-card>
            </div>
          </v-row>
        </v-container>
      </div>
    </div>
  </article>
</template>

<script>
import Carousel from '@/components/common/Carousel'
import { bus, image } from '@/api'
import eventBus from '@/utils/eventBus'
export default {
  name: 'Bus',
  components: {
    Carousel
  },
  data: () => ({
    busList: null,
    bus: {
      carNumber: '',
      size: 0,
      comments: '',
      images: []
    },
    busImage: {
      images: [],
      deleteTarget: [],
      addTarget: []
    },
    mode: null,
    files: [],
    activeIndex: null,
    valid: true
  }),
  created () {
    this.fetchList()
  },
  methods: {
    async fetchList () {
      const { data } = await bus.list()
      this.busList = data
    },
    async createBus () {
      await this.processAddImage()
      const { data } = await bus.create(this.bus)
      eventBus.$emit('alert', { active: true, text: '등록 되었습니다.' })
      await this.fetchList()
      this.setCurrentBus(data)
      this.activeIndex = this.busList.findIndex(x => x.id === data.id)
    },
    async updateBus () {
      await this.processAddImage()
      await this.processDeleteImage()
      const { data } = await bus.set(this.bus.id, this.bus)
      this.setCurrentBus(data)
      eventBus.$emit('alert', { active: true, text: '수정 되었습니다.' })
      await this.fetchList()
    },
    async processAddImage () {
      for (const i in this.busImage.addTarget) {
        const { data } = await image.create(this.makeFileFormData(this.busImage.addTarget[i].file))
        this.bus.images.push(data.name)
      }
    },
    processDeleteImage () {
      for (const i in this.busImage.deleteTarget) {
        const imageIndex = this.bus.images.indexOf(this.busImage.deleteTarget[i])
        this.bus.images.splice(imageIndex, 1)
      }
    },
    makeFileFormData (file) {
      const formData = new FormData()
      formData.append('sourceFile', file)
      return formData
    },
    setCreateMode () {
      this.bus = { id: 0, images: [] }
      this.mode = 'CREATE'
      this.busImage = {
        images: [],
        deleteTarget: [],
        addTarget: []
      }
      this.activeIndex = null
    },
    setCurrentBus (bus) {
      this.bus = { ...bus }
      this.busImage = {
        images: [],
        deleteTarget: [],
        addTarget: []
      }
      this.busImage.images = bus.images
      this.mode = 'UPDATE'
    },
    async onSubmit () {
      try {
        eventBus.$emit('showLoading')
        if (this.mode === 'CREATE') {
          await this.createBus()
        }
        if (this.mode === 'UPDATE') {
          await this.updateBus()
        }
      } catch (e) {
        eventBus.$emit('alert', { active: true, text: '에러!' })
      } finally {
        eventBus.$emit('hideLoading')
      }
    },
    async onRemoveConfirm () {
      await bus.delete(this.bus.id)
      eventBus.$emit('alert', { active: true, text: '제거되었습니다.' })
      this.setCreateMode()
      await this.fetchList()
    },
    onRemoveBus () {
      eventBus.$emit('dialog',
        {
          active: true,
          msg: '버스를 정말 제거하시겠습니까?',
          okText: '버스제거',
          confirmHandler: {
            ok: () => {
              this.onRemoveConfirm()
            }
          }
        }
      )
    },
    selectMainItem (index) {
      this.activeIndex = index
    }
  }
}
</script>

<style lang="scss">
  .theme--light {
    &.left {
      /*margin-top: 70px;*/
      /*left: 256px;*/
      /*box-shadow: 2px 4px 6px 0 rgba(0, 0, 0, 0.12);*/
      &.v-navigation-drawer:not(.v-navigation-drawer--floating) {
        .v-navigation-drawer__border {
          background: none;
        }
      }
    }
  }
</style>
